export default "__VITE_ASSET__BQC4aOLk__"